import { render, staticRenderFns } from "./SymptomCart.vue?vue&type=template&id=1b0193cb&scoped=true&"
import script from "./SymptomCart.vue?vue&type=script&lang=js&"
export * from "./SymptomCart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0193cb",
  null
  
)

export default component.exports